import { render, staticRenderFns } from "./ActivityGoodsItem.vue?vue&type=template&id=133c0d27&scoped=true"
import script from "./ActivityGoodsItem.vue?vue&type=script&lang=js"
export * from "./ActivityGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityGoodsItem.vue?vue&type=style&index=0&id=133c0d27&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c0d27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133c0d27')) {
      api.createRecord('133c0d27', component.options)
    } else {
      api.reload('133c0d27', component.options)
    }
    module.hot.accept("./ActivityGoodsItem.vue?vue&type=template&id=133c0d27&scoped=true", function () {
      api.rerender('133c0d27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/ActivityGoodsItem.vue"
export default component.exports